// CommonJS on purpose: webpack (Gatsby) imports it fine, and the functions
// test suite requires it directly for the cross-runtime parity check
// (dioscuro/functions/lib/__tests__/permissionsParity.test.js).
const canAccessSales = (role, tags) =>
  role === "admin" ||
  (role === "staff" && Array.isArray(tags) && tags.includes("sales"));

const canAccessMentor = (role, tags) =>
  role === "admin" ||
  (role === "staff" && Array.isArray(tags) && tags.includes("mentor"));

module.exports = { canAccessSales, canAccessMentor };
